module.exports = __webpack_public_path__ + "img/repair.79678f16.jpg";